import { Pipe, PipeTransform } from "@angular/core";


@Pipe({
    name:'smartlinkDemoLicenseFilter'
})
export class LicenseFilterPipe implements PipeTransform{
    transform(info,nameFilter,emailFilter,mobileNOFilter,licenseKeyFilter) {
        if(info.length===0 || (nameFilter=='' && emailFilter=='' && mobileNOFilter=='' && licenseKeyFilter=='')){
            return info;
        }
        else{
            return info.filter((license)=>{
                if(nameFilter!='' && emailFilter!='' && mobileNOFilter!='' && licenseKeyFilter!=''){
                    return (license.Name.trim().toLowerCase()===nameFilter.trim().toLowerCase() && license.EmailId.toLowerCase()===emailFilter.toLowerCase() && license.MobileNo===mobileNOFilter && license.LicenseKey.toLowerCase()===licenseKeyFilter.toLowerCase())     
                }
                else if(nameFilter!='' && emailFilter=='' && mobileNOFilter!='' && licenseKeyFilter!=''){
                    return (license.Name.trim().toLowerCase()===nameFilter.trim().toLowerCase() && license.MobileNo===mobileNOFilter && license.LicenseKey.toLowerCase()===licenseKeyFilter.toLowerCase())
                }
                else if(nameFilter!='' && emailFilter!='' && mobileNOFilter=='' && licenseKeyFilter!=''){
                    return (license.Name.trim().toLowerCase()===nameFilter.trim().toLowerCase() && license.EmailId.toLowerCase()===emailFilter.toLowerCase() && license.LicenseKey.toLowerCase()===licenseKeyFilter.toLowerCase())     
                }
                else if(nameFilter!='' && emailFilter!='' && mobileNOFilter!='' && licenseKeyFilter==''){
                    return (license.Name.trim().toLowerCase()===nameFilter.trim().toLowerCase() && license.EmailId.toLowerCase()===emailFilter.toLowerCase() && license.MobileNo===mobileNOFilter)     
                }
                else if(nameFilter=='' && emailFilter!='' && mobileNOFilter!='' && licenseKeyFilter!=''){
                    return (license.EmailId.toLowerCase()===emailFilter.toLowerCase() && license.MobileNo===mobileNOFilter && license.LicenseKey.toLowerCase()===licenseKeyFilter.toLowerCase())     
                }
                else if(nameFilter=='' && emailFilter=='' && mobileNOFilter!='' && licenseKeyFilter!=''){
                    return (license.MobileNo===mobileNOFilter && license.LicenseKey.toLowerCase()===licenseKeyFilter.toLowerCase())     
                }
                else if(nameFilter=='' && emailFilter!='' && mobileNOFilter=='' && licenseKeyFilter!=''){
                    return (license.EmailId.toLowerCase()===emailFilter.toLowerCase() && license.LicenseKey.toLowerCase()===licenseKeyFilter.toLowerCase())     
                }
                else if(nameFilter=='' && emailFilter!='' && mobileNOFilter!='' && licenseKeyFilter==''){
                    return (license.EmailId.toLowerCase()===emailFilter.toLowerCase() && license.MobileNo===mobileNOFilter)     
                }
                else if(nameFilter!='' && emailFilter!='' && mobileNOFilter!='' && licenseKeyFilter!=''){
                    return (license.Name.trim().toLowerCase()===nameFilter.trim().toLowerCase() && license.EmailId.toLowerCase()===emailFilter.toLowerCase() && license.MobileNo===mobileNOFilter && license.LicenseKey.toLowerCase()===licenseKeyFilter.toLowerCase())     
                }
                else if(nameFilter!='' && emailFilter=='' && mobileNOFilter=='' && licenseKeyFilter==''){
                    return (license.Name.trim().toLowerCase()===nameFilter.trim().toLowerCase())     
                }
                else if(nameFilter!='' && emailFilter=='' && mobileNOFilter=='' && licenseKeyFilter!=''){
                    return (license.Name.trim().toLowerCase()===nameFilter.trim().toLowerCase() && license.LicenseKey.toLowerCase()===licenseKeyFilter.toLowerCase())     
                }
                else if(nameFilter!='' && emailFilter=='' && mobileNOFilter!='' && licenseKeyFilter==''){
                    return (license.Name.trim().toLowerCase()===nameFilter.trim().toLowerCase() && license.MobileNo===mobileNOFilter)     
                }
                else if(nameFilter=='' && emailFilter!='' && mobileNOFilter=='' && licenseKeyFilter==''){
                    return (license.EmailId.toLowerCase()===emailFilter.toLowerCase())     
                }
                else if(nameFilter!='' && emailFilter!='' && mobileNOFilter=='' && licenseKeyFilter==''){
                    return (license.Name.trim().toLowerCase()===nameFilter.trim().toLowerCase() && license.EmailId.toLowerCase()===emailFilter.toLowerCase())     
                }
                else if(nameFilter=='' && emailFilter=='' && mobileNOFilter!='' && licenseKeyFilter==''){
                    return (license.MobileNo===mobileNOFilter)     
                }
                else if(nameFilter=='' && emailFilter=='' && mobileNOFilter=='' && licenseKeyFilter!=''){
                    return (license.LicenseKey.toLowerCase()===licenseKeyFilter.toLowerCase())     
                }
            })
        }
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/license-portal/filter.pipe.ts